import { fg } from '@atlassian/jira-feature-gating';
import { RAPID_VIEW_ROUTE_CONFIG } from './rapidViewRouteConfig.constants.tsx';
import type { RapidViewRouteConfig } from './RapidViewRouteConfig.types.tsx';
import {
	WRM_BOARD_RESOURCES_FHD_ARRAY,
	WRM_BACKLOG_RESOURCES_FHD_ARRAY,
	WRM_RESOURCES_ARRAY,
} from './resourceTypeRapidboardsWrmBundle.constants.tsx';

const RAPID_VIEW_ROUTE_CONFIG_OLD: Record<string, RapidViewRouteConfig> = {
	BOARD: {
		routes: [
			'rapidboard-board',
			'rapidboard-board-embed',
			'rapidboard-user-board',
			'servicedesk-boards',
			'servicedesk-queues-custom-board',
			'servicedesk-queues-practice-custom-board',
		],
		resources: WRM_BOARD_RESOURCES_FHD_ARRAY,
		stateKey: 'board-state',
	},
	BACKLOG: {
		routes: ['rapidboard-backlog', 'rapidboard-user-backlog', 'rapidboard-backlog-embed'],
		resources: WRM_BACKLOG_RESOURCES_FHD_ARRAY,
		stateKey: 'backlog-state',
	},
	DEFAULT: {
		resources: WRM_RESOURCES_ARRAY,
		stateKey: 'report-state',
	},
} as const;

export const getRapidViewConfigFromRouteName = (routeName: string): RapidViewRouteConfig => {
	const rapidViewRouteConfig = fg('csm_appification_standalone_navigation')
		? RAPID_VIEW_ROUTE_CONFIG
		: RAPID_VIEW_ROUTE_CONFIG_OLD;
	for (const routeConfig of Object.values(rapidViewRouteConfig)) {
		if (routeConfig.routes?.includes(routeName)) {
			return routeConfig;
		}
	}
	return rapidViewRouteConfig.DEFAULT;
};
